import CloseBtn from 'components/buttons/button-close';
import HandleDuplicateEmail from 'components/forms/handlers/errors/handleDuplicateEmail';
import HandleDuplicateLocation from 'components/forms/handlers/errors/handleDuplicateLocation';
import HandleGenericError from 'components/forms/handlers/errors/handleGenericError';
import HandleRegistrationLimitExceeded from 'components/forms/handlers/errors/handleRegistrationLimitExceeded';
import HandleTooManyRequests from 'components/forms/handlers/errors/handleTooManyRequests';

import './styles/signup-reponse-error.scss';

type SignupResponseErrorProps = {
  bypassDuplicateWorkplace?: boolean,
  claimedNumber?: number,
  className: string,
  closeErrResponse: () => void,
  duplicateWorkplace?: () => void,
  formValues?: any,
  responseNumber: number,
  uniqueId?: string
}

const SignupResponseError = ({ responseNumber, closeErrResponse, className, uniqueId, formValues, claimedNumber, duplicateWorkplace, bypassDuplicateWorkplace }:SignupResponseErrorProps) => {

  const hasErrorCode = responseNumber;
  const hasLocationError = hasErrorCode === 2721;
  const hasEmailError = hasErrorCode === 5140;
  const hasRegistrationLimitError = hasErrorCode === 9001;
  const hasTooManyRequestsError = hasErrorCode === 429;
  
  const ErrorMessage = ({ handleClose }) => {
    switch (true) {
      case hasEmailError: return <HandleDuplicateEmail handleClose={ handleClose } />;
        break;
      case hasLocationError && !bypassDuplicateWorkplace: return <HandleDuplicateLocation handleClose={ handleClose } uniqueId={ uniqueId } formValues={ formValues } claimedNumber={ claimedNumber } duplicateWorkplace={ duplicateWorkplace } />;
        break;
      case hasRegistrationLimitError: return <HandleRegistrationLimitExceeded handleClose={ handleClose } />;
        break;
      case hasTooManyRequestsError: return <HandleTooManyRequests handleClose={ handleClose } />;
        break
      default: return <HandleGenericError handleClose={ handleClose } />;
    } 
  };

  const handleClose = () => closeErrResponse();

  return (
    <section className={ `signup-response-error-modal-container ${className} signupResponseOverlay` } data-section="signup response error">
      <div className="error-container">
        <CloseBtn
          className="close-btn"
          onClick={ handleClose }
        />
        <ErrorMessage handleClose={ handleClose } />
      </div>
    </section>
  );
};

export default SignupResponseError;
